// Generated by purs version 0.13.0
"use strict";
var Chip_Model_Direction = require("../Chip.Model.Direction/index.js");
var Chip_Model_Enemy = require("../Chip.Model.Enemy/index.js");
var Chip_Model_Level = require("../Chip.Model.Level/index.js");
var Chip_Model_Tile = require("../Chip.Model.Tile/index.js");
var Chip_Mutation_Direction = require("../Chip.Mutation.Direction/index.js");
var Chip_Mutation_Enemy = require("../Chip.Mutation.Enemy/index.js");
var Chip_Mutation_Inventory = require("../Chip.Mutation.Inventory/index.js");
var Chip_Mutation_Point = require("../Chip.Mutation.Point/index.js");
var Chip_Mutation_Tile = require("../Chip.Mutation.Tile/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Boolean = require("../Data.Boolean/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_EuclideanRing = require("../Data.EuclideanRing/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Map_Internal = require("../Data.Map.Internal/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Set = require("../Data.Set/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Data_Unfoldable = require("../Data.Unfoldable/index.js");
var toggleWalls = function (level) {
    return {
        player: level.player,
        tiles: Data_Functor.map(Data_Map_Internal.functorMap)(Chip_Mutation_Tile.toggleWall)(level.tiles),
        inventory: level.inventory,
        chipsLeft: level.chipsLeft,
        hint: level.hint,
        enemies: level.enemies,
        blocks: level.blocks,
        trapConnections: level.trapConnections,
        ticksLeft: level.ticksLeft,
        tick: level.tick
    };
};
var toggleTanks = function (level) {
    return {
        player: level.player,
        tiles: level.tiles,
        inventory: level.inventory,
        chipsLeft: level.chipsLeft,
        hint: level.hint,
        enemies: Data_Functor.map(Data_Map_Internal.functorMap)(Chip_Mutation_Enemy.toggleTank)(level.enemies),
        blocks: level.blocks,
        trapConnections: level.trapConnections,
        ticksLeft: level.ticksLeft,
        tick: level.tick
    };
};
var removeTile = function (point) {
    return function (level) {
        return {
            player: level.player,
            tiles: Data_Map_Internal["delete"](Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
                return "y";
            }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                return "x";
            }))(Data_Ord.ordInt)))(point)(level.tiles),
            inventory: level.inventory,
            chipsLeft: level.chipsLeft,
            hint: level.hint,
            enemies: level.enemies,
            blocks: level.blocks,
            trapConnections: level.trapConnections,
            ticksLeft: level.ticksLeft,
            tick: level.tick
        };
    };
};
var removeEnemy = function (p) {
    return function (l) {
        return {
            player: l.player,
            tiles: l.tiles,
            inventory: l.inventory,
            chipsLeft: l.chipsLeft,
            hint: l.hint,
            enemies: Data_Map_Internal["delete"](Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
                return "y";
            }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                return "x";
            }))(Data_Ord.ordInt)))(p)(l.enemies),
            blocks: l.blocks,
            trapConnections: l.trapConnections,
            ticksLeft: l.ticksLeft,
            tick: l.tick
        };
    };
};
var removeCurrentTile = function (level) {
    return removeTile(level.player.pos)(level);
};
var pickUpChip = function (level) {
    if (level.chipsLeft === 0) {
        return removeCurrentTile(level);
    };
    if (Data_Boolean.otherwise) {
        return removeCurrentTile({
            player: level.player,
            tiles: level.tiles,
            inventory: level.inventory,
            chipsLeft: level.chipsLeft - 1 | 0,
            hint: level.hint,
            enemies: level.enemies,
            blocks: level.blocks,
            trapConnections: level.trapConnections,
            ticksLeft: level.ticksLeft,
            tick: level.tick
        });
    };
    throw new Error("Failed pattern match at Chip.Mutation.Level (line 70, column 1 - line 70, column 29): " + [ level.constructor.name ]);
};
var onInventory = function (f) {
    return function (level) {
        return {
            player: level.player,
            tiles: level.tiles,
            inventory: f(level.inventory),
            chipsLeft: level.chipsLeft,
            hint: level.hint,
            enemies: level.enemies,
            blocks: level.blocks,
            trapConnections: level.trapConnections,
            ticksLeft: level.ticksLeft,
            tick: level.tick
        };
    };
};
var pickUp = function (item) {
    var $66 = onInventory(Chip_Mutation_Inventory.addItem(item));
    return function ($67) {
        return removeCurrentTile($66($67));
    };
};
var moveToSocket = function (pos) {
    return function (level) {
        if (level.chipsLeft === 0) {
            return removeCurrentTile({
                player: {
                    pos: pos,
                    direction: level.player.direction,
                    turnedAt: level.player.turnedAt,
                    movedAt: level.player.movedAt
                },
                tiles: level.tiles,
                inventory: level.inventory,
                chipsLeft: level.chipsLeft,
                hint: level.hint,
                enemies: level.enemies,
                blocks: level.blocks,
                trapConnections: level.trapConnections,
                ticksLeft: level.ticksLeft,
                tick: level.tick
            });
        };
        if (Data_Boolean.otherwise) {
            return level;
        };
        throw new Error("Failed pattern match at Chip.Mutation.Level (line 41, column 1 - line 41, column 40): " + [ pos.constructor.name, level.constructor.name ]);
    };
};
var moveBlock = function (from) {
    return function (to) {
        return function (level) {
            return {
                player: level.player,
                tiles: level.tiles,
                inventory: level.inventory,
                chipsLeft: level.chipsLeft,
                hint: level.hint,
                enemies: level.enemies,
                blocks: Data_Set.insert(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
                    return "y";
                }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                    return "x";
                }))(Data_Ord.ordInt)))(to)(Data_Set["delete"](Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
                    return "y";
                }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                    return "x";
                }))(Data_Ord.ordInt)))(from)(level.blocks)),
                trapConnections: level.trapConnections,
                ticksLeft: level.ticksLeft,
                tick: level.tick
            };
        };
    };
};
var addEnemy = function (p) {
    return function (enemy) {
        return function (l) {
            return {
                player: l.player,
                tiles: l.tiles,
                inventory: l.inventory,
                chipsLeft: l.chipsLeft,
                hint: l.hint,
                enemies: Data_Map_Internal.insert(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
                    return "y";
                }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                    return "x";
                }))(Data_Ord.ordInt)))(p)(enemy)(l.enemies),
                blocks: l.blocks,
                trapConnections: l.trapConnections,
                ticksLeft: l.ticksLeft,
                tick: l.tick
            };
        };
    };
};
var cloneEnemies = function (level) {
    var withTile = function (lvl) {
        return function (v) {
            if (v.value1 instanceof Chip_Model_Tile.CloneMachine) {
                return addEnemy(v.value0)(v.value1.value0)(lvl);
            };
            return lvl;
        };
    };
    return Data_Foldable.foldl(Data_Foldable.foldableArray)(withTile)(level)(Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray)(level.tiles));
};
var addBlock = function (p) {
    return function (l) {
        return {
            player: l.player,
            tiles: l.tiles,
            inventory: l.inventory,
            chipsLeft: l.chipsLeft,
            hint: l.hint,
            enemies: l.enemies,
            blocks: Data_Set.insert(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
                return "y";
            }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                return "x";
            }))(Data_Ord.ordInt)))(p)(l.blocks),
            trapConnections: l.trapConnections,
            ticksLeft: l.ticksLeft,
            tick: l.tick
        };
    };
};
var act = function (initLevel) {
    var withNewPos = function (pos) {
        return function (oldPos) {
            return function (enemy) {
                return function (level) {
                    var v = Data_Map_Internal.lookup(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
                        return "y";
                    }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                        return "x";
                    }))(Data_Ord.ordInt)))(pos)(level.tiles);
                    if (v instanceof Data_Maybe.Just && v.value0 instanceof Chip_Model_Tile.CloneMachineButton) {
                        return cloneEnemies(removeEnemy(oldPos)(addEnemy(pos)(enemy)(level)));
                    };
                    if (v instanceof Data_Maybe.Just && v.value0 instanceof Chip_Model_Tile.Water) {
                        return removeEnemy(oldPos)(level);
                    };
                    if (v instanceof Data_Maybe.Just && v.value0 instanceof Chip_Model_Tile.Bomb) {
                        return removeEnemy(oldPos)(removeTile(pos)(level));
                    };
                    return removeEnemy(oldPos)(addEnemy(pos)(enemy)(level));
                };
            };
        };
    };
    var goTo = function (level) {
        return function (pos) {
            return function (direction) {
                return function (enemy) {
                    return function (dirs) {
                        var v = Data_Array.uncons(Data_Array.filter((function () {
                            var $68 = Chip_Model_Level.isFloor(level);
                            var $69 = Chip_Mutation_Point.adjustPoint(pos);
                            return function ($70) {
                                return $68($69($70));
                            };
                        })())(dirs));
                        if (v instanceof Data_Maybe.Just) {
                            return {
                                pos: Chip_Mutation_Point.adjustPoint(pos)(v.value0.head),
                                enemy: enemy(v.value0.head)
                            };
                        };
                        if (v instanceof Data_Maybe.Nothing) {
                            return {
                                pos: pos,
                                enemy: enemy(direction)
                            };
                        };
                        throw new Error("Failed pattern match at Chip.Mutation.Level (line 112, column 5 - line 117, column 51): " + [ v.constructor.name ]);
                    };
                };
            };
        };
    };
    var add = function (pos) {
        return function (enemy) {
            return function (v) {
                return {
                    level: addEnemy(pos)(enemy)(v.level),
                    old: v.old
                };
            };
        };
    };
    var act$prime = function (level) {
        return function (v) {
            var verticalDirection = (function () {
                if (v.y > level.player.pos.y) {
                    return new Data_Maybe.Just(Chip_Model_Direction.Up.value);
                };
                if (v.y < level.player.pos.y) {
                    return new Data_Maybe.Just(Chip_Model_Direction.Down.value);
                };
                if (Data_Boolean.otherwise) {
                    return Data_Maybe.Nothing.value;
                };
                throw new Error("Failed pattern match at Chip.Mutation.Level (line 149, column 5 - line 152, column 28): " + [  ]);
            })();
            var horizontalDirection = (function () {
                if (v.x > level.player.pos.x) {
                    return new Data_Maybe.Just(Chip_Model_Direction.Left.value);
                };
                if (v.x < level.player.pos.x) {
                    return new Data_Maybe.Just(Chip_Model_Direction.Right.value);
                };
                if (Data_Boolean.otherwise) {
                    return Data_Maybe.Nothing.value;
                };
                throw new Error("Failed pattern match at Chip.Mutation.Level (line 154, column 5 - line 157, column 28): " + [  ]);
            })();
            return function (v1) {
                if (Chip_Model_Level.isActiveTrap(v)(level)) {
                    return {
                        pos: v,
                        enemy: v1
                    };
                };
                if (v1 instanceof Chip_Model_Enemy.Bee) {
                    return goTo(level)(v)(v1.value0)(Chip_Model_Enemy.Bee.create)([ Chip_Mutation_Direction.toLeft(v1.value0), v1.value0, Chip_Mutation_Direction.toRight(v1.value0), Chip_Mutation_Direction.invert(v1.value0) ]);
                };
                if (v1 instanceof Chip_Model_Enemy.FireBall) {
                    return goTo(level)(v)(v1.value0)(Chip_Model_Enemy.FireBall.create)([ v1.value0, Chip_Mutation_Direction.toRight(v1.value0), Chip_Mutation_Direction.toLeft(v1.value0), Chip_Mutation_Direction.invert(v1.value0) ]);
                };
                if (v1 instanceof Chip_Model_Enemy.Glider) {
                    return goTo(level)(v)(v1.value0)(Chip_Model_Enemy.Glider.create)([ v1.value0, Chip_Mutation_Direction.toLeft(v1.value0), Chip_Mutation_Direction.toRight(v1.value0), Chip_Mutation_Direction.invert(v1.value0) ]);
                };
                if (v1 instanceof Chip_Model_Enemy.Tank && Chip_Model_Level.isFloor(level)(Chip_Mutation_Point.adjustPoint(v)(v1.value0))) {
                    return {
                        pos: Chip_Mutation_Point.adjustPoint(v)(v1.value0),
                        enemy: new Chip_Model_Enemy.Tank(v1.value0)
                    };
                };
                if (v1 instanceof Chip_Model_Enemy.Tank) {
                    return {
                        pos: v,
                        enemy: new Chip_Model_Enemy.Tank(v1.value0)
                    };
                };
                if (v1 instanceof Chip_Model_Enemy.Ball && Chip_Model_Level.isFloor(level)(Chip_Mutation_Point.adjustPoint(v)(v1.value0))) {
                    return {
                        pos: Chip_Mutation_Point.adjustPoint(v)(v1.value0),
                        enemy: new Chip_Model_Enemy.Ball(v1.value0)
                    };
                };
                if (v1 instanceof Chip_Model_Enemy.Ball && Chip_Model_Level.isFloor(level)(Chip_Mutation_Point.adjustPoint(v)(Chip_Mutation_Direction.invert(v1.value0)))) {
                    return {
                        pos: Chip_Mutation_Point.adjustPoint(v)(Chip_Mutation_Direction.invert(v1.value0)),
                        enemy: new Chip_Model_Enemy.Ball(Chip_Mutation_Direction.invert(v1.value0))
                    };
                };
                if (v1 instanceof Chip_Model_Enemy.Ball) {
                    return {
                        pos: v,
                        enemy: new Chip_Model_Enemy.Ball(Chip_Mutation_Direction.invert(v1.value0))
                    };
                };
                if (v1 instanceof Chip_Model_Enemy.Teeth && Data_EuclideanRing.mod(Data_EuclideanRing.euclideanRingInt)(level.tick)(4) !== 0) {
                    return {
                        pos: v,
                        enemy: new Chip_Model_Enemy.Teeth(v1.value0)
                    };
                };
                if (v1 instanceof Chip_Model_Enemy.Teeth) {
                    return goTo(level)(v)(v1.value0)(Chip_Model_Enemy.Teeth.create)(Data_Array.catMaybes([ verticalDirection, horizontalDirection ]));
                };
                throw new Error("Failed pattern match at Chip.Mutation.Level (line 120, column 31 - line 145, column 59): " + [ v1.constructor.name ]);
            };
        };
    };
    var foldEnemies = function ($copy_v) {
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(v) {
            var v1 = Data_Map_Internal.findMin(v.old);
            if (v1 instanceof Data_Maybe.Just) {
                var v2 = act$prime(v.level)(v1.value0.key)(v1.value0.value);
                var $58 = Data_Eq.eq(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()(new Data_Symbol.IsSymbol(function () {
                    return "y";
                }))(Data_Eq.eqInt))()(new Data_Symbol.IsSymbol(function () {
                    return "x";
                }))(Data_Eq.eqInt)))(v2.pos)(v1.value0.key);
                if ($58) {
                    $copy_v = {
                        level: v.level,
                        old: Data_Map_Internal["delete"](Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
                            return "y";
                        }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                            return "x";
                        }))(Data_Ord.ordInt)))(v1.value0.key)(v.old)
                    };
                    return;
                };
                $copy_v = {
                    level: withNewPos(v2.pos)(v1.value0.key)(v2.enemy)(v.level),
                    old: Data_Map_Internal["delete"](Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
                        return "y";
                    }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                        return "x";
                    }))(Data_Ord.ordInt)))(v1.value0.key)(v.old)
                };
                return;
            };
            if (v1 instanceof Data_Maybe.Nothing) {
                $tco_done = true;
                return v.level;
            };
            throw new Error("Failed pattern match at Chip.Mutation.Level (line 102, column 32 - line 108, column 21): " + [ v1.constructor.name ]);
        };
        while (!$tco_done) {
            $tco_result = $tco_loop($copy_v);
        };
        return $tco_result;
    };
    return foldEnemies({
        level: initLevel,
        old: initLevel.enemies
    });
};
module.exports = {
    addEnemy: addEnemy,
    addBlock: addBlock,
    act: act,
    moveBlock: moveBlock,
    moveToSocket: moveToSocket,
    removeCurrentTile: removeCurrentTile,
    onInventory: onInventory,
    removeTile: removeTile,
    toggleTanks: toggleTanks,
    toggleWalls: toggleWalls,
    pickUpChip: pickUpChip,
    pickUp: pickUp
};
